export enum LICENSE_NAME {
  AI_ASSIST_PRO = "ai_assist_pro",
  ANALYTICS_PLUS = "analytics_plus",
  AIRCALL_AI = "aircall_ai",
  WHATSAPP_MESSAGING = "whatsapp_messaging",
  SALESFORCE_SERVICE_CLOUD_VOICE = "salesforce_service_cloud_voice",
}

export enum FEATURE_NAME {
  AI_STANDARD_ACCESS = "ai_standard_access",
  // enable the evaluation tab
  EVALUATION_TAB_ACCESS = "evaluation_tab_access",
}

export const FEATURE_LICENSES_MAPPING = {
  [FEATURE_NAME.AI_STANDARD_ACCESS]: [
    LICENSE_NAME.AIRCALL_AI,
    LICENSE_NAME.AI_ASSIST_PRO,
  ],
  [FEATURE_NAME.EVALUATION_TAB_ACCESS]: [
    LICENSE_NAME.AIRCALL_AI,
    LICENSE_NAME.AI_ASSIST_PRO,
  ],
};
